'use client';

import { useEffect, useState } from 'react';

import { About } from '@/components/About';
import { Achievements } from '@/components/Achievements';
import {
  AutoScrolled,
  DirectionCarousel,
  FullwidthCarousel,
  MainCarousel,
  PeopleCarousel,
} from '@/components/Carousel/Carousels';
import { Form } from '@/components/Form';
import { useIntersectionObserveForms } from '@/hooks/useIntersectionObserverForms';
import { useWindowWidth } from '@/hooks/useWindowWidth';
import { FilterType } from '@/types';
import { fetchData } from '@/utils/fetchData';

import { Banner, Hero } from './components';

const MOCK_DESCRIPTIONS_SLIDES = [
  {
    title: 'Разработка',
    link: '/vacancies',
    description:
      'Frontend, Backend, Data science, DevOps, тестировщики и SRE – здесь разрабатываются внутренние и внешние продукты Cloud.ru: от HR-портала до AI-решений.',
  },
  {
    title: 'Инженеры',
    link: '/vacancies',
    description:
      'Инженеры Cloud.ru отвечают за поддержку и развитие цифровой инфраструктуры — основу всех наших сервисов.',
  },
  {
    title: 'Кибербезопасность',
    link: '/vacancies',
    description:
      'Кибербезопасность в Cloud.ru является залогом доверия наших заказчиков. Инженеры киберзащиты обеспечивают безопасность и надежность всего цифрового периметра.',
  },
  {
    title: 'Архитектура',
    link: '/vacancies',
    description:
      'Архитекторы создают модель системы наших продуктов: от построения логических моделей данных до структуры процессов.',
  },
  {
    title: 'Аналитики',
    link: '/vacancies',
    description:
      'Команды аналитиков строят data driven подход и помогают принимать важные для бизнеса решения на основе данных.',
  },
  {
    title: 'Продажи и развитие бизнеса',
    link: '/vacancies',
    description:
      'Команды продаж в Cloud.ru работают по двум направлениям: операционный пайплайн и исследование новых рынков и возможностей.',
  },
  {
    title: 'Продуктовая команда',
    link: '/vacancies',
    description:
      'Продуктовая команда Cloud.ru отвечает за то, чтобы наши продукты приносили максимальную ценность для бизнеса клиентов и партнеров.',
  },
  {
    title: 'Маркетинг и PR',
    link: '/vacancies',
    description:
      'Маркетинг и PR продвигают бренд Cloud.ru на рынке, рассказывают клиентам об облачных и AI-технологиях, развивают сообщества людей, увлеченных инновациями, а еще делают яркие ивенты.',
  },
  {
    title: 'Поддержка бизнеса',
    link: '/vacancies',
    description:
      'Направления, без которых ни один бизнес не может существовать: HR, юристы, отдел закупок, логистика, служба безопасности и т.д.',
  },
  {
    title: 'Технический писатель',
    link: '/vacancies',
    description:
      'Технические писатели разрабатывают внешнюю и внутреннюю документацию, а также создают интерфейсные тексты для наших продуктов.',
  },
];

const MOCK_DESCRIPTIONS_CAROUSEL = {
  title: 'Начни свой путь в Cloud.ru <br />в одном из направлений',
  subtitle: 'вакансии',
  button: { title: 'Смотреть все вакансии', link: '/vacancies' },
};

const MOCK_PEOPLE_SLIDES = [
  {
    badge: {
      name: 'Роман Путилов',
      position: 'Менеджер продуктов',
    },
    image: 'https://cdn.cloud.ru/backend/career/people-carousel/slide-1.png',
    description:
      '«Cloud.ru дает свободу и все ресурсы, необходимые для выполнения задач. Благодаря этому я делаю большие проекты, ощущая поддержку и доверие руководства».',
  },
  {
    badge: {
      name: 'Юлия Хайретдинова',
      position: 'Бренд-специалист',
    },
    image: 'https://cdn.cloud.ru/backend/career/people-carousel/slide-3.png',
    description:
      '«Самое крутое в нашей компании — люди. Мне повезло работать с профессионалами, у которых большой опыт. Задачи решаются быстро и эффективно, даже те, которые казались нерешаемыми. А еще мне нравится, что мы открытые и не боимся выражать своe мнение».',
  },
  {
    badge: {
      name: 'Иван Щетинин',
      position: 'Руководитель группы',
    },
    image: 'https://cdn.cloud.ru/backend/career/people-carousel/slide-4.png',
    description:
      '«У нас есть возможность развиваться и повышать свою экспертизу. Работая в коммерческом блоке, я могу принимать участие в модернизации продуктов, проводить CX/UX-исследования, вместе с клиентами тестировать новые продукты».',
  },
  // {
  //   badge: {
  //     name: 'Владимир Шульга',
  //     position: 'Директор блока продуктовой разработки',
  //   },
  //   image: 'https://cdn.cloud.ru/backend/career/people-carousel/slide-5.png',
  //   description:
  //     '«Для меня самое ценное, что есть в Cloud.ru, — это возможность самовыражения. Здесь каждый может проявлять инициативу, предлагать новые решения и своей работой влиять на общий большой результат».',
  // },
  {
    badge: {
      name: 'Анатолий Бибиков',
      position:
        'Руководитель департамента по работе <br />с ключевыми клиентами',
    },
    image: 'https://cdn.cloud.ru/backend/career/people-carousel/slide-6.png',
    description:
      '«Атмосфера драйва и желания достичь результата. У нас амбициозные цели и мы постоянно ищем новые пути их достижения. Меня вдохновляет, когда я вижу, что с помощью наших сервисов клиенты реализуют свои идеи и создают новые продукты».',
  },
  {
    badge: {
      name: 'Светлана Громова',
      position: 'Руководитель финансового анализа <br />и планирования',
    },
    image: 'https://cdn.cloud.ru/backend/career/people-carousel/slide-7.png',
    description:
      '«Я работаю в команде настоящих профессионалов и потрясающих людей, каждый из которых уникален. Мы дополняем друг друга, вместе растем и развиваемся. У нас классный офис, где мы продуктивно работаем, решаем сложные задачи, проводим крутые встречи и вместе празднуем наши успехи».',
  },
  // {
  //   badge: {
  //     name: 'Надежда Ванина',
  //     position: 'Директор департамента цифрового <br />канала продаж',
  //   },
  //   image: 'https://cdn.cloud.ru/backend/career/people-carousel/slide-8.png',
  //   description:
  //     '«Мне очень нравится, что в компании прекрасно уживаются дух стартапа и лучшие практики мировых гигантов IT-индустрии. Я слышу от многих сотрудников, что за несколько месяцев в Cloud.ru они приобрели больше знаний и опыта, чем за несколько прошлых лет учебы и работы».',
  // },
];

const MOCK_PEOPLE_CAROUSEL = {
  slides: MOCK_PEOPLE_SLIDES,
  title: 'Люди Cloud.ru о работе в компании',
  subtitle: 'мнения людей',
};

const MOCK_ABOUT = {
  content: {
    title: 'о компании',
    desc: `<p> Cloud․ru — это
            <span>аккредитованная IT-компания</span> в сфере облачных и AI-технологий.
          </p>
          <p>
            Мы привлекаем амбициозных профессионалов по всей России, чтобы вместе
            создавать уникальные технологии и сервисы для наших клиентов.
          </p>`,
  },
};

const Index = () => {
  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();
  const [descriptionSlides, setDescriptionSLides] = useState<
    {
      title: string;
      link: string;
      description: string;
    }[]
  >([]);

  useEffect(() => {
    const getFilters = async () => {
      const response = await fetchData<FilterType[]>('/career/v1/filters');
      const filters: Record<string, number> = {};
      const units = response.find((item) => item.code === 'unit')?.items || [];
      units.forEach((unit) => {
        filters[unit.name] = unit.id;
      });

      const newDescrptionSlides = MOCK_DESCRIPTIONS_SLIDES.map((item) => {
        if (filters[item.title]) {
          return { ...item, link: `${item.link}?unit=${filters[item.title]}` };
        }
        return item;
      });

      setDescriptionSLides(newDescrptionSlides);
    };
    getFilters();
  }, []);

  const { formRef } = useIntersectionObserveForms({
    formName: 'career',
  });

  return (
    <main>
      <Hero />
      <About content={MOCK_ABOUT.content} />
      <Achievements />
      <MainCarousel />
      {windowWidth && windowWidth > MD ? (
        <AutoScrolled
          title={MOCK_DESCRIPTIONS_CAROUSEL.title}
          subtitle={MOCK_DESCRIPTIONS_CAROUSEL.subtitle}
          slides={descriptionSlides}
          variant="descriptions"
          button={MOCK_DESCRIPTIONS_CAROUSEL.button}
        />
      ) : (
        <DirectionCarousel slides={descriptionSlides} />
      )}
      <Banner />
      <PeopleCarousel slides={MOCK_PEOPLE_CAROUSEL.slides} />

      <FullwidthCarousel />
      <Form ref={formRef} />
    </main>
  );
};

export default Index;
